export default {
      id: "mqtt-usage",
      viewBox: "0 0 240 240",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#mqtt",
      toString: function () {
        return this.url;
      }
    }